// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__CbC5c","imageUploader":"EGiftCard_imageUploader__6910I"};